import React from 'react';
import ErrorSvg from '../../assets/error.svg';
import {
  Container,
  Wrapper,
  Label,
  Astericks,
  Input,
  Textarea,
  ErrorIcon,
  ErrorMessage,
} from '../styles/FormControl.styled';

const FormControl = ({
  id,
  type,
  name,
  placeholder,
  label,
  autoComplete,
  required,
  errorMessage,
  value,
  handleChange,
  hidden,
}) => {
  return (
    <Container
      className={`custom-form-control control-${name}`}
      hidden={hidden}
    >
      <Wrapper>
        <Label htmlFor={name}>
          {label}
          {required && <Astericks>*</Astericks>}
        </Label>
        {type === 'textarea' ? (
          <Textarea
            id={id}
            type={type}
            name={name}
            placeholder={placeholder}
            autoComplete={autoComplete}
            value={value}
            className={errorMessage ? 'error' : ''}
            onChange={e => handleChange(e)}
            rows="4"
          />
        ) : (
          <Input
            id={id}
            type={type}
            name={name}
            placeholder={placeholder}
            autoComplete={autoComplete}
            value={value}
            className={errorMessage ? 'error' : ''}
            onChange={e => handleChange(e)}
          />
        )}

        {errorMessage && (
          <ErrorIcon
            className="error-icon"
            src={ErrorSvg}
            alt="Error Icon"
            type={type}
          />
        )}
      </Wrapper>
      {errorMessage && (
        <ErrorMessage
          className="error-message"
          dangerouslySetInnerHTML={{ __html: errorMessage }}
          type={type}
        />
      )}
    </Container>
  );
};

export default FormControl;
